<section class="composicao-card-coluna">
    <div class="composicao-card-coluna-cabecalho">
        <div class="composicao-cabecalho-identidade">
            <div class="composicao-cabecalho-icone">
                <i class="pi pi-users"></i>
            </div>
            <div class="min-w-0">
                <span class="composicao-card-coluna-titulo">{{ titulo() }}</span>
                <span class="composicao-card-coluna-subtitulo">{{ subtitulo() }}</span>
            </div>
        </div>
        <span class="composicao-card-contador">{{ carregando() ? '-' : membros().length }}</span>
    </div>

    <div class="composicao-card-lista">
        @if (carregando()) {
            @for (_ of [1, 2, 3]; track _) {
                <div class="skeleton-membro"></div>
            }
        } @else {
            @for (item of membros(); track (item.idSolicitante ?? item.crm ?? item.nome) + item.uf) {
                <app-card-container class="composicao-card-membro">
                    <div class="composicao-card-membro-topo">
                        <div class="composicao-card-foto-coluna">
                            <div class="composicao-medico-foto">
                                @if (item.avatar) {
                                    <img [src]="item.avatar" [alt]="item.nome" />
                                } @else {
                                    <span>{{ iniciaisMembro(item.nome) }}</span>
                                }
                            </div>
                        </div>

                        <div class="composicao-card-info-coluna">
                            <div class="composicao-card-info-cabecalho">
                                <div class="composicao-medico-resumo">
                                    <h3 class="indicador-titulo truncate" [pTooltip]="item.nome">{{ item.nome }}</h3>
                                    <div class="composicao-medico-tags">
                                        <span class="tag-status-membro" [ngClass]="{ 'tag-afastado': item.idStatusMembro === 1, 'tag-ativo': item.idStatusMembro !== 1 }">
                                            {{ item.idStatusMembro === 1 ? 'Afastado' : 'Ativo' }}
                                        </span>
                                        <span class="tag-participacao" [ngClass]="obterClasseParticipacao(item)">
                                            {{ item.dsParticipacao || '-' }}
                                        </span>
                                    </div>
                                </div>

                                <div class="composicao-card-acoes-direita" (click)="$event.stopPropagation()">
                                    <div class="indicador-contagem">
                                        <div class="indicador-valor">{{ item.crm || '-' }}</div>
                                        <div class="indicador-label">{{ item.uf || 'UF' }}</div>
                                    </div>
                                    <button type="button" class="botao-visualizar-membro" [class.active]="isMembroExpanded(item)" (click)="toggleExpandMembro($event, item)" [pTooltip]="isMembroExpanded(item) ? 'Recolher' : 'Visualizar'">
                                        <i class="pi" [ngClass]="isMembroExpanded(item) ? 'pi-eye-slash' : 'pi-eye'"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="composicao-badges-status">
                                <span class="composicao-status-badge" [ngClass]="item.assinouLgpd ? 'badge-ok' : 'badge-alerta'">
                                    <i class="pi" [ngClass]="item.assinouLgpd ? 'pi-shield' : 'pi-shield-exclamation'"></i>
                                    <span>LGPD: {{ item.assinouLgpd ? 'Assinado' : 'Pendente' }}</span>
                                </span>
                                <span class="composicao-status-badge" [ngClass]="!item.devedor ? 'badge-ok' : 'badge-alerta'">
                                    <i class="pi" [ngClass]="!item.devedor ? 'pi-check-circle' : 'pi-exclamation-triangle'"></i>
                                    <span>Quitação: {{ item.devedor ? 'Devedor' : 'Quite' }}</span>
                                </span>
                                @if (item.telefones) {
                                    @for (tel of obterListaTelefones(item.telefones); track tel) {
                                        <button type="button" class="composicao-telefone-badge" [pTooltip]="'Clique para copiar: ' + tel" (click)="copiarTelefone(tel, $event)">
                                            <i class="pi pi-phone"></i>
                                            <span>{{ tel }}</span>
                                        </button>
                                        <app-send-whatsapp [text]="gerarMensagemWhatsappMembroDashboard(item)" [phone]="tel" [abrirDialog]="true" tooltip="Enviar WhatsApp para este telefone"></app-send-whatsapp>
                                    }
                                } @else {
                                    <span class="composicao-telefone-badge">
                                        <i class="pi pi-phone"></i>
                                        <span>Sem telefone</span>
                                    </span>
                                }
                                <div class="composicao-contato-acoes" (click)="$event.stopPropagation()">
                                    <button type="button" class="botao-visualizar-membro botao-copiar-contato" [disabled]="!possuiEmails(item.emails)" (click)="copiarEmailsMembro(item.emails, $event)" pTooltip="Copiar todos os e-mails">
                                        <i class="pi pi-envelope"></i>
                                    </button>
                                    <button type="button" class="botao-visualizar-membro botao-copiar-contato" [disabled]="!possuiTelefones(item.telefones)" (click)="copiarTelefonesMembro(item.telefones, $event)" pTooltip="Copiar todos os telefones">
                                        <i class="pi pi-phone"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="detalhes-expansiveis" [style.max-height]="isMembroExpanded(item) ? '1000px' : '0'" [style.opacity]="isMembroExpanded(item) ? '1' : '0'">
                                <div class="detalhes-expansiveis-conteudo">
                                    <div class="composicao-dados-periodo">
                                        <div>
                                            <strong>Entrada:</strong><br />
                                            {{ formatarDataExibicao(item.dtInicio) }}
                                        </div>
                                        <div>
                                            <strong>Saída:</strong><br />
                                            {{ formatarDataExibicao(item.dtFim) }}
                                        </div>
                                        <div>
                                            <strong>Portaria Entrada:</strong><br />
                                            {{ item.nuPortariaInclusao || '-' }}
                                        </div>
                                        <div>
                                            <strong>Portaria Saída:</strong><br />
                                            {{ item.nuPortariaRemocao || '-' }}
                                        </div>
                                    </div>

                                    @if (item.entidadeExterna || item.emails) {
                                        <div class="composicao-contato-bloco">
                                            @if (item.entidadeExterna) {
                                                <div class="truncate" [pTooltip]="item.entidadeExterna || '-'"><strong>Entidade:</strong> {{ item.entidadeExterna || '-' }}</div>
                                            }
                                            @if (item.emails) {
                                                <div class="emails">
                                                    <strong>E-mail:</strong>
                                                    <div>
                                                        @for (email of obterListaEmails(item.emails); track email) {
                                                            <button type="button" class="composicao-email-badge" [pTooltip]="'Clique para copiar: ' + email" (click)="copiarEmail(email, $event)">
                                                                <i class="pi pi-envelope"></i>
                                                                <span>{{ email }}</span>
                                                            </button>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </app-card-container>
            } @empty {
                <div class="composicao-card-vazio">
                    <i class="pi pi-inbox"></i>
                    <span>Nenhum membro encontrado.</span>
                </div>
            }
        }
    </div>
</section>
